
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValuationHistory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Valuation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastValueType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastValueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentValuePerSqft"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"history"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valueType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valueSource"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"zooplaComparableByUPRNsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uprns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zooplaComparableByUPRNs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uprns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uprns"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uprn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locality"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"propertyNumberOrName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"streetName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"townOrCity"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"propertySubType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newBuild"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorArea"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"energy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentEnergyRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentEnergyEfficiency"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"valuation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sale"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValuationHistory"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"rent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValuationHistory"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":839}};
    doc.loc.source = {"body":"fragment ValuationHistory on Valuation {\n  lastValue\n  lastValueType\n  lastValueDate\n  currentValue\n  currentValuePerSqft\n  history {\n    value\n    valueType\n    valueDate\n    valueSource\n  }\n}\nquery zooplaComparableByUPRNsV2($uprns: [String!]!) {\n  zooplaComparableByUPRNs(uprns: $uprns) {\n    uprn\n    location {\n      address {\n        postcode\n        countryCode\n        locality\n        propertyNumberOrName\n        streetName\n        townOrCity\n      }\n    }\n    attributes {\n      propertyType\n      propertySubType\n      bedrooms\n      receptions\n      bathrooms\n      newBuild\n      yearBuilt\n      tenure\n      floorArea\n    }\n    energy {\n      currentEnergyRating\n      currentEnergyEfficiency\n    }\n    valuation {\n      sale {\n        ...ValuationHistory\n      }\n      rent {\n        ...ValuationHistory\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ValuationHistory"] = oneQuery(doc, "ValuationHistory");
        
        module.exports["zooplaComparableByUPRNsV2"] = oneQuery(doc, "zooplaComparableByUPRNsV2");
        
